import script from "./StarsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./StarsComponent.vue?vue&type=script&setup=true&lang=js"

import "./StarsComponent.vue?vue&type=style&index=0&id=6f86ad11&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f86ad11"]])

export default __exports__